import { useState, useMemo, useCallback } from 'react';

export default function useOrderFilters(orders = []) {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [datePreset, setDatePreset] = useState('all');
  const [sortDir, setSortDir] = useState('newest');

  const filteredOrders = useMemo(() => {
    const q = search.trim().toLowerCase();
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const dateThreshold = {
      all: null,
      today: startOfToday, // calendar day boundary, not a rolling 24 h window
      last_7: new Date(now - 7 * 24 * 60 * 60 * 1000),
      last_30: new Date(now - 30 * 24 * 60 * 60 * 1000),
    }[datePreset];

    return [...orders]
      .filter(o => {
        if (!q) return true;
        const customer = o.customer || o.users;
        const listing = o.listing || o.listings;
        const name = `${customer?.first_name ?? ''} ${customer?.last_name ?? ''}`.toLowerCase();
        const title = (listing?.title ?? '').toLowerCase();
        const id = String(o.id).toLowerCase();
        return name.includes(q) || title.includes(q) || id.includes(q);
      })
      .filter(o => statusFilter === 'all' || o.status === statusFilter)
      .filter(o => {
        if (!dateThreshold) return true;
        return new Date(o.created_at) >= dateThreshold;
      })
      .sort((a, b) => {
        const diff = new Date(a.created_at) - new Date(b.created_at);
        return sortDir === 'newest' ? -diff : diff;
      });
  }, [orders, search, statusFilter, datePreset, sortDir]);

  const activeFilterCount = useMemo(() => [
    statusFilter !== 'all',
    datePreset !== 'all',
    sortDir !== 'newest',
  ].filter(Boolean).length, [statusFilter, datePreset, sortDir]);

  const clearFilters = useCallback(() => {
    setSearch('');
    setStatusFilter('all');
    setDatePreset('all');
    setSortDir('newest');
  }, []);

  return {
    filteredOrders,
    search, setSearch,
    statusFilter, setStatusFilter,
    datePreset, setDatePreset,
    sortDir, setSortDir,
    activeFilterCount,
    clearFilters,
  };
}
